import cx from 'classnames';
import { Upload } from 'tabler-icons-react';
import { fileType } from 'Utils';
import { Button } from 'Elements';
import styles from 'partials/upload-box.module.scss';

export const UploadBox = ({ type, className, onClick }) => {
	const rowClass = cx(styles.row, className);
	// const protocol = window.location.protocol;
	// const domain = window.location.hostname;
	// const port = window.location.port;

	return (
		<div className={rowClass}>
			<span className={styles.text}>
				در تکمیل محتوای این بخش سهیم باشید
			</span>
			<Button className={styles.button} onClick={onClick}>
				<Upload size={20} className={styles.icon} /> ارسال{' '}
				{fileType[type].title}
			</Button>
		</div>
	);
};
